import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import CostContext, { formatCentsToDollars } from '../contexts/CostContext'; // Assuming this exists, similar to ScanPaymentModal

const ExtraImprintPaymentModal = ({
  open,
  onClose,
  onConfirm,
  cardBrand,
  cardLast4,
}) => {
  const amount = CostContext.ImprintRemedy;
  const title = 'Extra Imprint Remedy Charge';

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: { xs: 340, sm: 420 },
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
          outline: 'none',
        }}
      >
        <Typography variant="h5" component="h2" gutterBottom>
          Confirm Extra Imprint Charge
        </Typography>

        <Typography sx={{ mb: 2 }}>
          This charge is for a second imprint remedy required based on the selected Focus Scans, only charge this to the practitioner if the scan requires 2 imprints.
        </Typography>

        <Typography sx={{ mb: 3, fontWeight: 500 }}>
          <strong>{title}</strong> (${formatCentsToDollars(amount)})
        </Typography>

        <Typography sx={{ mt: 2, mb: 3, textAlign: 'right' }}>
          Card: <strong>{cardBrand} x{cardLast4}</strong>
          <br />
          Total Charge: <strong>${formatCentsToDollars(amount)}</strong>
        </Typography>

        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end', mt: 4 }}>
          <Button variant="outlined" color="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="contained" color="primary" onClick={onConfirm}>
            Confirm Payment
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default ExtraImprintPaymentModal;